package nl.volleyplanner.api.planner

import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import nl.volleyplanner.api.entities.FullPerson
import nl.volleyplanner.api.sports.BasicTeam
import nl.volleyplanner.api.sports.Match


@Serializable
data class PersonTaskStatistics(
    val person: FullPerson,
    val personImpacts: List<ConstraintScoreImpact>,
    val tasksById: List<String>,
    val matchAmount: Int,
    val volunteerScore: Int
) {
    @Transient
    val totalScore = personImpacts
        .map { it.impact }
        .reduceOrNull { acc, score -> acc + score } ?: HardMediumSoftScore.ZERO
}

@Serializable
data class TaskStatistics(
    val task: Task,
    val taskImpacts: List<ConstraintScoreImpact>
) {
    @Transient
    val totalScore = taskImpacts
        .map { it.impact }
        .reduceOrNull { acc, score -> acc + score } ?: HardMediumSoftScore.ZERO
}

@Serializable
data class TaskAssignmentAdvice(
    val task: Task,
    val person: FullPerson,
    val personTeam: List<BasicTeam>,
    val personMatchesOnTaskDate: List<Match>,
    val personVolunteerScore: Int,
    val personMatchAmount: Int,
    val personTaskAmount: Int,
    val beforeScoreImpact: HardMediumSoftScore,
    val beforeScoreImpactList: List<ConstraintScoreImpact>,
    val scoreDelta: HardMediumSoftScore,
    val newScoreImpactList: List<ConstraintScoreImpact>,
    val afterScoreImpact: HardMediumSoftScore,
    val afterScoreImpactList: List<ConstraintScoreImpact>,
) : Comparable<TaskAssignmentAdvice> {
    companion object {
        val SCORE_COMPARATOR_ASC = compareBy<TaskAssignmentAdvice> { it.scoreDelta }
            .thenBy { it.task.id }
            .thenBy { it.person.name }
        val SCORE_COMPARATOR_DESC = compareByDescending<TaskAssignmentAdvice> { it.scoreDelta }
            .thenBy { it.task.id }
            .thenBy { it.person.name }
    }

    override fun compareTo(other: TaskAssignmentAdvice): Int {
        return SCORE_COMPARATOR_ASC.compare(this, other)
    }
}
